import DimSymbolsCommand, { DimType } from "slotworks/commands/symbols/dim-symbols-command";
import { HighlightSymbolsCommand } from "slotworks/commands/symbols/highlight-symbols-command";
import Components from "slotworks/components/components";
import GameState from "slotworks/model/game-state";
import FreespinRecord from "slotworks/model/gameplay/records/freespin-record";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Services } from "slotworks/services/services";
import { SoundEvent } from "slotworks/services/sound/sound-events";
import { StateMachine } from "slotworks/state-machine/state-machine";
import State from "slotworks/state-machine/states/state";

export default class SymbolCelebration extends State {

    private symbol: string;
    private messageKey: string;

    constructor(stateMachine: StateMachine, symbol: string, messageKey?: string) {
        super(stateMachine);

        this.symbol = symbol;
        this.messageKey = messageKey;
    }

    public onEnter() {
        const record = GameState.getCurrentGame().getCurrentRecord();
        const allSymbols = Components.matrix.getBaseGridSymbols();

        const symbols = [];

        for (const symbol of allSymbols) {
            if (symbol.symbolId === this.symbol) {
                symbols.push(symbol);
            }
        }

        Services.sound.event(SoundEvent.symbol_ID_celebrate, this.symbol);
        Services.sound.event(SoundEvent.symbol_any_celebrate);

        const hiddenSymbols = Components.matrix.getHiddenSymbols();
        DimSymbolsCommand(allSymbols.concat(hiddenSymbols), DimType.Win).execute();

        HighlightSymbolsCommand(symbols).then(() => {
            Components.matrix.resetSymbols();
            this.complete();
        });

        if (this.messageKey) {
            Components.footer.showCustomMessage(Services.translations.get(this.messageKey, { matches: symbols.length }));
        } else if (record && record instanceof SpinRecord) {
            const freespinsWon = record.getFreespinsWon();

            if (freespinsWon > 0) {
                if (record instanceof FreespinRecord) {
                    Components.footer.showFreeSpinsRetriggered(freespinsWon);
                } else {
                    Components.footer.showFreeSpinsTriggered(freespinsWon);
                }
            }
        }
    }
}
